'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var effects = require('@redux-saga/core/effects');



Object.keys(effects).forEach(function (k) {
	if (k !== 'default') Object.defineProperty(exports, k, {
		enumerable: true,
		get: function () {
			return effects[k];
		}
	});
});



//////////////////
// WEBPACK FOOTER
// ./~/redux-saga/dist/redux-saga-effects-npm-proxy.cjs.js
// module id = 486
// module chunks = 0